import React from 'react';
import classNames from 'classnames';

import { MirrorService } from 'services/MirrorService';

import { useHistoryBack } from 'hooks/useHistoryBack';

import { ReactComponent as FilterIcon } from 'assets/icons/meplusyou/filter.svg';
import { ReactComponent as NavBackIcon } from 'assets/icons/nav-back.svg';

import { BaseButton, ButtonTypes } from 'components/base/BaseButton';
import { Logo } from 'components/shared/Logo';

import css from './mainPageMobileHeaderTypeMeplusyou.module.sass';

interface Props {
  isBackBtnExists?: boolean;
  isFiltersExists?: boolean;
  className?: string;
  onBackBtnClick?: () => void;
  onFiltersBtnClick?: () => void;
}

export const MainPageMobileHeaderTypeMeplusyou: React.FC<Props> = ({
  isBackBtnExists,
  isFiltersExists,
  className,
  onBackBtnClick,
  onFiltersBtnClick,
}) => {
  const historyBack = useHistoryBack();

  return (
    <header className={classNames(css.root, className)}>
      {isBackBtnExists && (
        <BaseButton
          type={ButtonTypes.Transparent}
          className={classNames(css.btn, css.btnTypeBack)}
          onClick={onBackBtnClick ?? historyBack}
        >
          <NavBackIcon className={css.icon} />
        </BaseButton>
      )}
      <BaseButton type={ButtonTypes.Transparent} ariaLabel="home" to="/finder">
        <Logo dark={!MirrorService.isLustStation} hideBottomLine small />
      </BaseButton>
      {isFiltersExists && (
        <BaseButton
          type={ButtonTypes.Transparent}
          className={classNames(css.btn, css.btnTypeFilter)}
          ariaLabel="open filters"
          onClick={onFiltersBtnClick}
        >
          <FilterIcon className={css.icon} />
        </BaseButton>
      )}
    </header>
  );
};
